import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import './css/History.css';

export class History extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: ""
        };
    }

    componentDidMount() {
        fetch("/docs/update-history.md")
            .then((response) => {
                if (response.ok) return response.text();
                else return Promise.reject("Didn't fetch text correctly");
            })
            .then((text) => {
                this.setState({ content: text })
            })
            .catch((error) => console.error(error));
    }

    render() {
        const { content } = this.state
        return (
            <div className='history-page'>
                <ReactMarkdown children={content} />
            </div>
        );
    }
}